// AD FORMATS
export const AD_FORMATS = {
  VIDEO: { label: "Video", value: "video" },
  IMAGE: { label: "Image", value: "image" },
  TEXT: { label: "Text", value: "text" },
  CAROUSEL: { label: "Carousel", value: "carousel" },
};

// AD STATUS
export const AD_STATUS = {
  DRAFT: { label: "Draft", value: "draft" },
  ACTIVE: { label: "Active", value: "active" },
  INACTIVE: { label: "Inactive", value: "inactive" },
  EXPIRED: { label: "Expired", value: "expired" },
};

// MEDIA TYPES
export const AD_MEDIA_TYPES = {
  IMAGE: { label: "Image", value: "image" },
  VIDEO: { label: "Video", value: "video" },
  THUMBNAIL: { label: "Thumbnail", value: "thumbnail" },
};

// USER INTERACTIONS
export const AD_INTERACTION_TYPES = {
  VIEW: { label: "View", value: "view" },
  CLICK: { label: "Click", value: "click" },
};

// CONFIG
export const AD_CONFIG = {
  MAX_FILE_SIZE_MB: 2.5,
  MIN_BUDGET: 2000,
  MAX_BUDGET: 20000,
  REWARD_PROBABILITY: 0.2,
  AD_WATCH_EXPIRY_SECONDS: 3600,
  AD_WATCH_REDIS_PREFIX: "user:ad_watch:",
  MIN_PRIORITY: 1,
  MAX_PRIORITY: 100,
  DEFAULT_PRIORITY: 50,
  DEFAULT_AD_DURATION_DAYS: 30,
  MIN_IMPRESSIONS_GOAL: 1,
  MAX_IMPRESSIONS_GOAL: 10000000,
};

// ACTIVITY LOG TAGS
export const AD_ACTIVITY_TAGS = {
  AD_CREATED: { label: "Ad Created", value: "ad_created" },
  AD_UPDATED: { label: "Ad Updated", value: "ad_updated" },
  AD_DELETED: { label: "Ad Deleted", value: "ad_deleted" },
  AD_ACTIVATED: { label: "Ad Activated", value: "ad_activated" },
  AD_PAUSED: { label: "Ad Paused", value: "ad_paused" },
  AD_EXPIRED: { label: "Ad Expired", value: "ad_expired" },
  AD_GOAL_REACHED: { label: "Ad Goal Reached", value: "ad_goal_reached" },
};

// USER ACCOUNT TYPES
export const USER_ACCOUNT_TYPES = {
  BASIC: { label: "Basic", value: "basic" },
  STANDARD: { label: "Standard", value: "standard" },
  PREMIUM: { label: "Premium", value: "premium" },
  ELITE: { label: "Elite", value: "elite" },
};

// TIER COLORS - Color codes for each membership tier
export const TIER_COLORS = {
  [USER_ACCOUNT_TYPES.BASIC.value]: "#757575", // Gray
  [USER_ACCOUNT_TYPES.STANDARD.value]: "#1976d2", // Blue
  [USER_ACCOUNT_TYPES.PREMIUM.value]: "#d44402", // Orange
  [USER_ACCOUNT_TYPES.ELITE.value]: "#aa00ff", // Purple
};

// TIER ICONS - Icon names for each membership tier (MUI icon names)
export const TIER_ICONS = {
  [USER_ACCOUNT_TYPES.BASIC.value]: null, // No icon for basic
  [USER_ACCOUNT_TYPES.STANDARD.value]: "Verified",
  [USER_ACCOUNT_TYPES.PREMIUM.value]: "Star",
  [USER_ACCOUNT_TYPES.ELITE.value]: "Diamond",
};

// DEFAULT TIER BENEFITS
export const DEFAULT_TIER_BENEFITS = {
  [USER_ACCOUNT_TYPES.BASIC.value]: ["Basic features"],
  [USER_ACCOUNT_TYPES.STANDARD.value]: ["Standard features"],
  [USER_ACCOUNT_TYPES.PREMIUM.value]: ["Premium features"],
  [USER_ACCOUNT_TYPES.ELITE.value]: ["Elite features"],
};

// Admin Roles Constants
export const ADMIN_ROLES = Object.freeze({
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
});
